import { render, staticRenderFns } from "./TelehealthInformedConsent.vue?vue&type=template&id=b5eebc20"
import script from "./TelehealthInformedConsent.vue?vue&type=script&lang=js"
export * from "./TelehealthInformedConsent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports